import type { GQL_ID } from '@@partner:types:graphql'
import type { Menu } from '@@partner:types:app'

import { gql, useQuery } from '@apollo/client'

export interface SingleMenuQuery {
  singleMenu: Menu
}

export interface SingleMenuQueryVariables {
  id: GQL_ID
}

export const GQL_QUERY_SINGLE_MENU = gql`
  query ($id: ID!) {
    singleMenu(id: $id) {
      id
      name
      code
      type
      is_active
      created_at
      updated_at
      
      menuItems {
        id
        internal_name
        title

        image_file_id
        image {
          url
        }
        icon_code
        icon_color
        text_color
        link_url
        link_type
        bold
        is_active
        sort_order
        created_at
        updated_at
        
        translations {
          id
          menu_item_id
          created_at
          updated_at
          language_code
          title
        }
        
        i18n {
          id
          menu_item_id
          created_at
          updated_at
          language_code
          title
        }
      }
    }
  }
`

export const useFetchSingleMenu = (
  variables: SingleMenuQueryVariables,
  options?: { skip?: boolean }
) =>
  useQuery<SingleMenuQuery, SingleMenuQueryVariables>(GQL_QUERY_SINGLE_MENU, {
    variables,
    fetchPolicy: 'cache-and-network',
    ...options
  })
